import { useCallback } from 'react';
import type { FunctionComponent } from 'react';
import { useService } from '@xstate/react';
import interpreter from '../../state/service';
import OverviewScreen from './OverviewScreen.Container';
import Route from '../../utils/Route';

export interface StateProps {
	ratingAdded: boolean;
}

export interface DispatchProps {}

export interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;

const Overview: FunctionComponent<Props> = (props: Props) => {
	const { ratingAdded } = props;
	const [state, send] = useService(interpreter);

	const handleFinish = useCallback(() => {
		send('FINISH_PLAYTHROUGH', { wantFeedback: !ratingAdded });
	}, [send, ratingAdded]);

	return (
		<>
			<Route key="overview" state={state} stateId="overview">
				<OverviewScreen onFinish={handleFinish} />
			</Route>
		</>
	);
};

export default Overview;
